import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\" id=\"icon-arrow-right\"><circle cx=\"13\" cy=\"13\" r=\"13\" fill=\"#FFB11D\" /><path fill=\"#000\" d=\"M17.354 12.646a.5.5 0 0 1 0 .708l-3.182 3.181a.5.5 0 1 1-.708-.707L16.293 13l-2.829-2.828a.5.5 0 1 1 .708-.708l3.182 3.182ZM8 13.5a.5.5 0 0 1 0-1v1Zm9 0H8v-1h9v1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol